export const BASE_PATH = '/';
export const AUTH_REGISTER_PATH = `/signup/`


export const endpoints = {
    AUTH_REGISTER_CREATE: '/api/agency/registration'
}
